import { Box, Grid, Typography, Stack } from "@mui/material"
import { UserMeetings } from "../components/upcomingOrders/meetings/UserMeetings"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { UserPurchases } from "../components/upcomingOrders/purchases/UserPurchases"
import { CanteenInfo } from "../components/canteen/CanteenInfo"
import { OffersSection } from "../components/canteen/offers/OffersSection"
import { NewsSection } from "../components/canteen/news/NewsSection"
import { TodayMenuSection } from "../components/canteen/menu/TodayMenuSection"
import { useState } from "react"
import { RoomFinderDrawer } from "../components/roomFinder/RoomFinderDrawer"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { useAppDispatch, useAppSelector } from "../../../../store/storeHooks"
import { selectUserId } from "../../../../login/loginSelectors"
// import { ModuleName } from "../../../../users/userTypes"
import { CreateOrderType } from "../../../../../shared/components/createOrder/helpers"
import { FinalSuccessDialogContent } from "../../../../../shared/components/createOrder/components/finalSuccessDialog/FinalSuccessDialogContent"
import { getUserDetails, UserQuery } from "../../../../users/userApi"
// import { FindRoom } from "../components/canteen/FindRoom"
import { makeStyles } from "tss-react/mui"
import { useOrderDialogUrlState } from "../../../../../shared/components/createOrder/hooks/useOrderDialogUrlState"
import { RefetchIntervals } from "../../../../../core/api/refetchIntervals"

const useStyles = makeStyles()(() => ({
    container: {
        paddingTop: "3rem",
    },
}))

export function UserReportsHome() {
    const { classes } = useStyles()
    const userId = useAppSelector(selectUserId)
    const [isRoomFinderOpen, setIsRoomFinderOpen] = useState(false)
    const { openDialog } = useOrderDialogUrlState()

    const dispatch = useAppDispatch()
    const [finalSuccessDialog, setFinalSuccessDialog] = useState(false)
    const [orderId, setOrderId] = useState<number>()

    const { data: userDetails } = useApiQuery(getUserDetails, {
        queryName: UserQuery.USER_DETAILS,
        dependencies: {
            userId: userId ?? 0,
        },
        enabled: Boolean(userId),
        refetchInterval: RefetchIntervals.medium,
    })

    const activeModules = new Set(userDetails?.user?.modules?.filter((m) => m.isActive)?.map((m) => m.name))

    const handleOpenSuccessDialog = (orderId: number) => {
        setOrderId(orderId)
        setFinalSuccessDialog(true)
    }

    return (
        <Box className={classes.container}>
            <Stack direction={{ xs: "column", md: "row" }} spacing={{ md: "3rem", xl: "5rem" }}>
                <Grid item xs={12} md={6}>
                    <Stack direction="column" spacing="1rem">
                        <LocalizedStrict id="user-home-upcoming-orders">
                            <Typography variant="h2" lineHeight={0.8} pb=".5rem" fontWeight={500}>
                                Upcoming orders
                            </Typography>
                        </LocalizedStrict>
                        <Grid container spacing={2} xs={12} md={12}>
                            <UserMeetings />
                            <UserPurchases />
                        </Grid>
                    </Stack>
                </Grid>

                <Grid item xs={12} md={6}>
                    <CanteenInfo />
                    {/* <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
                    >
                        {activeModules.has(ModuleName.BOOKING) && (
                            <FindRoom
                                onOpenRoomFinder={() => {
                                    setIsRoomFinderOpen(true)
                                }}
                            />
                        )}
                    </MatchEnvironment> */}
                    <OffersSection />
                    <TodayMenuSection />
                    <NewsSection />
                </Grid>
            </Stack>

            <RoomFinderDrawer
                open={isRoomFinderOpen}
                openSuccessDialog={handleOpenSuccessDialog}
                onClose={() => setIsRoomFinderOpen(false)}
            />

            {finalSuccessDialog && (
                <FinalSuccessDialogContent
                    open={finalSuccessDialog}
                    onClose={() => setFinalSuccessDialog(false)}
                    handleNewOrder={() => {
                        setIsRoomFinderOpen(true)
                        setFinalSuccessDialog(false)
                    }}
                    handleAddMeetingService={() => {
                        openDialog({
                            orderId: orderId,
                            mode: "edit",
                            activeOrderTab: CreateOrderType.MEETING_SERVICE,
                        })
                        setFinalSuccessDialog(false)
                    }}
                    handleFinish={() => setFinalSuccessDialog(false)}
                />
            )}
        </Box>
    )
}
